import axios from 'axios';

const SANDBOX_MODE = false;
const BASE_URL = SANDBOX_MODE ? 'https://api-test.envia.com' : 'https://api.envia.com';
const QUERIES_URL = SANDBOX_MODE ? 'https://queries-test.envia.com' : 'https://queries.envia.com';
export const RATE_ENDPOINT = `${BASE_URL}/ship/rate/`;
export const GENERATE_ENDPOINT = `${BASE_URL}/ship/generate/`;

const API_TOKEN =  '93611e1330421b790ade63b030b4aa4fb4350eb5aab5b491d417f77eae2f627a';
// const API_TOKEN = '572b578b31bc2e059f6b1e5b2f35c1887a5d8746c6fe046e388975edd3eb6408';
const HEADERS = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${API_TOKEN}`,
};

const ensureApiToken = () => {
  if (!API_TOKEN) throw new Error('API token is missing or invalid.');
};


const generatePayload = async (orderDetails, shippingDetails, carrier, serviceName, cart, isRateQuery = false) => {
  if (!carrier || !serviceName || !shippingDetails.country || !shippingDetails.postalCode || !cart?.length) {
    throw new Error('Missing required fields: carrier, serviceName, country, postalCode, or cart.');
  }

  const countryCode = shippingDetails.country.slice(0, 2).toUpperCase();
  if (!validateZipCode(shippingDetails.postalCode, countryCode)) {
    throw new Error(`Invalid postal code '${shippingDetails.postalCode}' for country '${countryCode}'.`);
  }

  const stateCode = await mapStateToCode(shippingDetails.state || '', countryCode);
  const isCod = orderDetails.paymentMethod?.toUpperCase() === 'COD';
  const codAmount = isCod ? orderDetails.totalPrice : 0;

  const groupedItems = cart.reduce((acc, item) => {
    const key = `${item.name}-${item.size || ''}-${item.color || ''}`;
    acc[key] = acc[key] || { ...item, quantity: 0 };
    acc[key].quantity += item.quantity || 1;
    return acc;
  }, {});

  const packages = Object.values(groupedItems).map((item) => {
    const basePackage = {
      content: `${item.name}${item.color ? ' - ' + item.color : ''}${item.size ? ' - ' + item.size : ''} x${item.quantity}`,
      amount: 1,
      type: 'box',
      weight: (item.weight || 0.1) * item.quantity,
      insurance: item.insurance || 0,
      declaredValue: item.declaredValue || 0,
      weightUnit: 'KG',
      lengthUnit: 'CM',
      dimensions: item.dimensions || {
        length: 20,
        width: 15,
        height: 5 * Math.ceil(item.quantity / 2),
      }
    };

    if (isCod) {
      basePackage.additionalServices = [
        {
          service: 'cash_on_delivery',
          data: {
            amount: codAmount
          }
        }
      ];
    }

    return basePackage;
  });

  return {
    origin: {
      name: 'Layne Red',
      company: 'Layne Red',
      email: 'laynered.mails@gmail.com',
      phone: '+919207207469',
      street: 'Vandanam Po',
      number: '',
      district: 'Alappuzha',
      city: 'Valanjavazhi',
      state: 'KE',
      country: 'IN',
      postalCode: '688005',
      reference: ''
    },
    destination: {
      name: shippingDetails.fullName || 'Recipient',
      company: shippingDetails.company || '',
      email: shippingDetails.email || 'recipient@example.com',
      phone: shippingDetails.phone || '8606821125',
      street: shippingDetails.street || 'Default Street',
      number: shippingDetails.number || '1',
      district: shippingDetails.district || 'Default District',
      city: shippingDetails.city || 'Default City',
      state: stateCode,
      country: countryCode,
      postalCode: shippingDetails.postalCode,
      reference: ''
    },
    packages,
    shipment: {
      carrier: carrier.toLowerCase(),
      service: serviceName,
      type: 1
    },
    settings: {
      printFormat: 'PDF',
      printSize: 'STOCK_4X6',
      comments: isRateQuery ? undefined : 'Order dispatched from Laynered Warehouse'
    }
  };
};



export const createRateQuery = async (orderDetails, shippingDetails, carrier, serviceName, cart) => {
  ensureApiToken();
  try {
    const payload = await generatePayload(orderDetails, shippingDetails, carrier, serviceName, cart, true);
    const response = await axios.post(RATE_ENDPOINT, payload, { headers: HEADERS });
    if (response.data.meta === 'error') {
      throw new Error(response.data.error.description || 'Rate query failed');
    }
    if (!response.data.data?.length) {
      throw new Error('No rate data returned');
    }

    return { success: true, data: response.data.data };
  } catch (error) {
    console.error('Rate Query Error:', { message: error.message, response: error.response?.data });
    return { success: false, error: error.message };
  }
};

export const enviaGenerateOrder = async (orderDetails, shippingDetails, carrier, serviceName, cart) => {
  ensureApiToken();
  try {
    const payload = await generatePayload(orderDetails, shippingDetails, carrier, serviceName, cart);

    const response = await axios.post(GENERATE_ENDPOINT, payload, { headers: HEADERS });

    const shipments = response.data?.data;

    if (!Array.isArray(shipments) || shipments.length === 0) {
      throw new Error('No shipment data returned');
    }

    const results = shipments.map((item) => {
      return {
        trackingNumber: item.trackingNumber || 'N/A',
        shipmentId: item.shipmentId || 'N/A',
        trackingUrl: item.trackUrl || 'N/A',
      };
    });

    return {
      success: true,
      data: results.length === 1 ? results[0] : results,
    };
  } catch (error) {
    console.error('❌ Generate Order Error:', {
      message: error.message,
      response: error.response?.data,
    });
    return { success: false, error: error.message };
  }
};


export const scheduleAllPickups = async (orders) => {
  try {
    ensureApiToken();
    const totalPackages = orders.reduce((acc, order) => acc + (order.packages?.length || 1), 0);
    const totalWeight = orders.reduce((acc, order) => acc + (order.packages?.reduce((w, item) => w + (item.weight || 1), 0) || 1), 0);

    const now = new Date();
    const pickupDate = new Date(now);
    const centralOffset = -6;
    const currentCentralHour = (now.getUTCHours() + centralOffset + 24) % 24;
    const currentCentralDay = now.getUTCDay();

    const sameDayEligible = currentCentralHour < 14 && ![0, 6].includes(currentCentralDay);
    if (!sameDayEligible) {
      do {
        pickupDate.setUTCDate(pickupDate.getUTCDate() + 1);
      } while ([0, 6].includes(pickupDate.getUTCDay()));
    }

    const pickupDateStr = pickupDate.toISOString().split('T')[0];
    const firstOrder = orders[0];

    const pickupPayload = {
      origin: { ...firstOrder.origin, country: firstOrder.origin.country.slice(0, 2) },
      shipment: {
        carrier: 'ecomexpress',
        type: 1,
        pickup: {
          timeFrom: 12,
          timeTo: 16,
          date: pickupDateStr,
          instructions: `Pick up ${totalPackages} packages totaling ${totalWeight} KG.`,
          totalPackages,
          totalWeight,
        },
      },
      settings: { currency: 'INR', labelFormat: 'pdf' },
    };

    const response = await axios.post(`${BASE_URL}/ship/pickup/`, pickupPayload, { headers: HEADERS });
    if (response.data.meta === 'error') throw new Error(response.data.error.description);

    return {
      success: true,
      data: { date: pickupDateStr, totalPackages, trackingNumber: response.data.data?.trackingNumber },
    };
  } catch (error) {
    console.error('Pickup Error:', error);
    return { success: false, error: error.message };
  }
};

export const createManifest = async (trackingNumbers) => {
  try {
    ensureApiToken();
    const payload = { trackingNumbers, settings: { currency: 'INR', labelFormat: 'pdf' } };
    const response = await axios.post(`${BASE_URL}/ship/manifest/`, payload, { headers: HEADERS });

    if (response.data.meta === 'error') throw new Error(response.data.error.description);
    return {
      success: true,
      data: { manifestLink: response.data.data?.manifestLink || `${BASE_URL}/manifest/${response.data.data?.id}` },
    };
  } catch (error) {
    console.error('Manifest Error:', error);
    return { success: false, error: error.message };
  }
};

export const trackShipments = async (trackingNumbers) => {
  try {
    ensureApiToken();
    if (!trackingNumbers?.length) throw new Error('No tracking numbers provided');
    const payload = { trackingNumbers: trackingNumbers.map(String) };
    const response = await axios.post(`${BASE_URL}/ship/generaltrack/`, payload, { headers: HEADERS });
    if (response.data.meta !== 'generaltrack') throw new Error('Invalid tracking response');
    return response.data;
  } catch (error) {
    console.error('Tracking Error:', error);
    throw error;
  }
};

export const cancelOrder = async (order) => {
  ensureApiToken();
  const trackingId = order.trackingNumber || order.id;
  if (!trackingId) throw new Error('Tracking number or order ID required.');

  const payload = {
    carrier: order.carrier || 'ecomexpress',
    trackingNumber: String(trackingId),
    folio: order.folio,
    ecommerce: order.ecommerce,
  };

  try {
    const response = await axios.post(`${BASE_URL}/ship/cancel/`, payload, { headers: HEADERS });
    if (response.data.meta === 'error') throw new Error(response.data.error.description);
    return true;
  } catch (error) {
    console.error('Cancel Error:', error);
    throw new Error(error.message);
  }
};

export const getCountries = async () => {
  try {
    ensureApiToken();
    const response = await axios.get(`${QUERIES_URL}/country`, { headers: HEADERS });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Countries Error:', error);
    return [];
  }
};

export const getAvailableCarriers = async (countryCode, isInternational) => {
  try {
    ensureApiToken();
    const internationalFlag = isInternational ? 1 : 0;
    const response = await axios.get(`${QUERIES_URL}/available-carrier/${countryCode}/${internationalFlag}`, { headers: HEADERS });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Carriers Error:', error);
    return [];
  }
};

export const getCourierDetails = async (carrierName, countryCode) => {
  try {
    ensureApiToken();
    const response = await axios.get(`${QUERIES_URL}/service/${carrierName}?country_code=${countryCode}`, { headers: HEADERS });
    const details = response.data.data || response.data;
    return Array.isArray(details) ? details : [details];
  } catch (error) {
    console.error('Courier Details Error:', error);
    return [];
  }
};

export const getStates = async (countryCode) => {
  try {
    ensureApiToken();
    const response = await axios.get(`${QUERIES_URL}/state?country_code=${countryCode}`, { headers: HEADERS });
    return response.data.data || response.data;
  } catch (error) {
    console.error('States Error:', error);
    return [];
  }
};

export const mapStateToCode = async (stateName, countryCode) => {
  try {
    const states = await getStates(countryCode || 'IN');
    const stateObj = states.find((s) => 
      (s.name?.toLowerCase() === stateName.toLowerCase()) || 
      (s.code?.toLowerCase() === stateName.toLowerCase())
    );
    return stateObj?.code || stateName.slice(0, 2).toUpperCase() || 'XX';
  } catch (error) {
    console.error('State Mapping Error:', error);
    return stateName.slice(0, 2).toUpperCase() || 'XX';
  }
};

export const validateZipCode = (zipCode, countryCode) => {
  const zipPatterns = {
    MX: /^\d{5}$/,
    IN: /^\d{6}$/,
    US: /^\d{5}(-\d{4})?$/,
  };
  return zipPatterns[countryCode]?.test(zipCode) || false;
};

export const generateOrderId = () => `order-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;